var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.display
    ? _c("div", { staticClass: "property-select" }, [
        _c(
          "div",
          {
            staticClass: "property-select__input",
            class: {
              "property-select__input--readonly-calendar-picker": _vm.isReadOnly
            }
          },
          [
            !_vm.isReadOnly
              ? _c("CalendarPicker", {
                  attrs: {
                    calendar: _vm.calendar,
                    calendars: _vm.calendars,
                    "show-calendar-on-select": true
                  },
                  on: { selectCalendar: _vm.selectCalendar }
                })
              : _c("CalendarPickerOption", {
                  attrs: {
                    color: _vm.calendar.color,
                    "display-name": _vm.calendar.displayName,
                    "is-shared-with-me": _vm.calendar.isSharedWithMe,
                    owner: _vm.calendar.owner
                  }
                })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }